import { cSolicitante } from "./../../modelos/solicitante.modelo";
import { ApiAppService } from "./../../servicios/apiapp.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm, NgModel } from "@angular/forms";
import { FormControl, Validators, FormGroup, Form } from "@angular/forms";
import { Router } from "@angular/router";
import * as myGlobals from "../../modelos/globales.modelo";
import * as Solicitante from "../../modelos/solicitante.modelo";
import * as Cita from "../../modelos/cita.modelo";
import Swal from "sweetalert2";
import { MatAccordion } from "@angular/material/expansion";
import { environment } from "@environments/environment";

// Declaramos las variables para jQuery
declare let jquery: any;
declare let $: any;

@Component({
  selector: "app-ver-citas",
  templateUrl: "vercitas.component.html",
  styleUrls: ["vercitas.component.css"],
  providers: [ApiAppService],
  standalone: false,
})
export class VerCitasComponent implements OnInit {
  @ViewChild("acordeon", { static: true }) oAcordeon: MatAccordion;
  @ViewChild("frmSolicitante") myFormLogin: NgForm;
  panelOpenState = true;

  public sFiltroNIF: string;
  public sFiltroEMAIL: string;
  public sTICKET: string;
  public oSolicitanteCitasPendientes: Solicitante.ISolicitanteCitasPendientes;
  public aDetalleCitas: Cita.cDetalleCita[] = [];
  public emailvalido: boolean;
  public sEnRepresentacionDe: string;

  constructor(
    public oRouter: Router,
    public _ApiAppService: ApiAppService
  ) {
    this.sFiltroNIF = "";
    this.sFiltroEMAIL = "";
    this.sTICKET = "";
    this.aDetalleCitas = null;
    this.oSolicitanteCitasPendientes = null;
    this.emailvalido = true;
    this.sEnRepresentacionDe = "";
  }

  ngOnInit() {
    let oSolicitante: Solicitante.ISolicitante = null;
    let sSolicitante: string;

    $(".capa-cita").addClass("visible");

    // Comprobamos si existe en la sesión se ha creado una cita y
    // tenemos información del solicitante. Si la tenemos recuperamos
    // su DNI y email para que no tenga que volverlo a teclear

    sSolicitante = myGlobals.getSessionStore(
      myGlobals.eSessionStore.osolicitante
    );
    if (!myGlobals.isNullUndefinedVacio(sSolicitante)) {
      oSolicitante = JSON.parse(sSolicitante);
      this.sFiltroNIF = oSolicitante.nif;
      this.sFiltroEMAIL = oSolicitante.email;
    }
  }

  onSubmitSolicitante() {
    let existeCita = false;

    // Validamos el resto del formulario
    if (this.myFormLogin.invalid) {
      return false;
    }

    // Validamos el email
    if (!this.ValidarEmail()) {
      return false;
    }

    this.sFiltroNIF = this.sFiltroNIF.toUpperCase();
    this.sFiltroEMAIL = this.sFiltroEMAIL.toLowerCase();
    this.sTICKET = this.sTICKET.toUpperCase();

    this.oSolicitanteCitasPendientes = null;
    this.aDetalleCitas = null;

    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Comprobando datos, espere ...",
      ""
    );

    // Comprobamos si existe el solicitante y además tiene citas pendientes

    this._ApiAppService
      .ObtenerCitasPendientesSolicitante(this.sFiltroNIF, this.sFiltroEMAIL)
      .subscribe(
        (data) => {
          if (myGlobals.isNullUndefined(data)) {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.Advertencia,
              "",
              "No existe ninguna persona con este documento y email dado de alta en el sistema.",
              ""
            );
          } else {
            // Cargamos en la variable el valor retornado del servicio
            this.oSolicitanteCitasPendientes = data;

            // Quitamos las citas que no se encuentren en estado pendientes

            for (
              let i =
                this.oSolicitanteCitasPendientes.CITAS_PENDIENTES.length - 1;
              i >= 0;
              i--
            ) {
              if (
                this.oSolicitanteCitasPendientes.CITAS_PENDIENTES[
                  i
                ].ticket.toUpperCase() === this.sTICKET &&
                this.oSolicitanteCitasPendientes.CITAS_PENDIENTES[i].estado ===
                  "P"
              ) {
                existeCita = true;
                break;
              }
            }

            if (
              this.oSolicitanteCitasPendientes.CITAS_PENDIENTES.length === 0
            ) {
              this.oSolicitanteCitasPendientes = null;
            }

            if (existeCita) {
              this.CrearDetalleCitas();
              myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
            } else {
              this.oSolicitanteCitasPendientes = null;
              myGlobals.Mensaje(
                myGlobals.eTipoMensaje.Advertencia,
                "",
                "No existe ninguna cita pendiente con esta información.",
                ""
              );
            }
          }
        },
        (err) => {
          myGlobals.CapturaMensajeHTTP(err, true);
        }
      );
  }

  // Valida si el email es correcto
  ValidarEmail(): boolean {
    if (!myGlobals.isNullUndefinedVacio(this.sFiltroEMAIL)) {
      this.emailvalido = myGlobals.validarEmail(this.sFiltroEMAIL);
      return this.emailvalido;
    } else {
      return false;
    }
  }

  // Crea el detalle de las citas recibidas del solicitante
  CrearDetalleCitas(): void {
    this.aDetalleCitas = [];
    const oSolicitante: Solicitante.ISolicitante =
      this.oSolicitanteCitasPendientes.SOLICITANTE;
    this.sEnRepresentacionDe = "";

    for (const oCita of this.oSolicitanteCitasPendientes.CITAS_PENDIENTES) {
      // Sólo mostramos la cita del ticket introducido

      if (oCita.ticket.toUpperCase() === this.sTICKET) {
        // Departamento y área

        const oDetalleCita = new Cita.cDetalleCita();
        oDetalleCita.id_cita = oCita.id_cita;
        oDetalleCita.AREA = oCita.DTO_AREA;

        // Fecha y hora de la cita

        const f: Date = myGlobals.fechaAAAAMMDDtoDate(oCita.fecha.toString());
        oDetalleCita.FECHA_HORA_CITA =
          myGlobals.fechaDateATexto(f, true) + " a las " + oCita.HHMM;

        oDetalleCita.ticket = oCita.ticket;
        oDetalleCita.estado = Cita.EstadoCitaToString(oCita.estado);

        // Información del trámite a gestionar

        oDetalleCita.TRAMITE = oCita.TRAMITE;
        oDetalleCita.INFO_TRAMITE = oCita.INFO_TRAMITE;
        oDetalleCita.DOCUMENTACION = [];
        for (const oDocumento of oCita.DOCUMENTOS) {
          let sInfo: string = oDocumento.DOCUMENTO;

          switch (oDocumento.tipo) {
            case "O":
              sInfo = sInfo + " - Original";
              break;
            case "F":
              sInfo = sInfo + " - Fotocopia";
              break;
            case "C":
              sInfo = sInfo + " - Fotocopia compulsada";
              break;
          }
          if (oDocumento.OBLIGATORIO) {
            sInfo = sInfo + " (Obligatorio)";
          } else {
            sInfo = sInfo + " (Opcional)";
          }
          oDetalleCita.DOCUMENTACION.push(sInfo);
        }

        // Información de videollamada
        oDetalleCita.telematica = oCita.telematica;
        oDetalleCita.url_video_solicitante = oCita.url_video_solicitante;

        // Cargamos la información adicional

        oDetalleCita.SOLICITANTE_NIF = oSolicitante.nif;
        oDetalleCita.SOLICITANTE = oSolicitante.nombre;
        if (!myGlobals.isNullUndefinedVacio(oSolicitante.apellido2)) {
          oDetalleCita.SOLICITANTE =
            oDetalleCita.SOLICITANTE + " " + oSolicitante.apellido1;
        }
        if (!myGlobals.isNullUndefinedVacio(oSolicitante.apellido2)) {
          oDetalleCita.SOLICITANTE =
            oDetalleCita.SOLICITANTE + " " + oSolicitante.apellido2;
        }
        oDetalleCita.SOLICITANTE_TLF1 = oSolicitante.tlf1;
        if (!myGlobals.isNullUndefinedVacio(oSolicitante.tlf2)) {
          oDetalleCita.SOLICITANTE_TLF2 = oDetalleCita.SOLICITANTE_TLF2;
        }
        oDetalleCita.SOLICITANTE_EMAIL = oSolicitante.email;
        if (myGlobals.isNullUndefinedVacio(oCita.motivo)) {
          oDetalleCita.MOTIVO_CITA = "";
        } else {
          oDetalleCita.MOTIVO_CITA = oCita.motivo;
        }

        // Datos del representado

        if (!myGlobals.isNullUndefined(oCita.REPRESENTADO)) {
          oDetalleCita.REPRESENTADO_NIF = oCita.REPRESENTADO.nif;
          oDetalleCita.REPRESENTADO_EMAIL = oCita.REPRESENTADO.email;

          this.sEnRepresentacionDe = oCita.REPRESENTADO.nombre;
          if (!myGlobals.isNullUndefinedVacio(oCita.REPRESENTADO.apellido1)) {
            this.sEnRepresentacionDe += " " + oCita.REPRESENTADO.apellido1;
          }
          if (!myGlobals.isNullUndefinedVacio(oCita.REPRESENTADO.apellido2)) {
            this.sEnRepresentacionDe += " " + oCita.REPRESENTADO.apellido2;
          }
        }
        this.aDetalleCitas.push(oDetalleCita);
        break;
      }
    }
  }

  // Retorna si hay citas pendientes del solicitante
  HayCitas(): boolean {
    return (
      !myGlobals.isNullUndefined(this.aDetalleCitas) &&
      this.aDetalleCitas.length > 0
    );
  }

  // Comprueba si el solicitante se encuentra logado
  SolicitanteLogado(): boolean {
    return !myGlobals.isNullUndefined(this.oSolicitanteCitasPendientes);
  }

  ConfirmarAnulacion(index: number): void {
    if (
      !myGlobals.isNullUndefined(this.aDetalleCitas) &&
      index <= this.aDetalleCitas.length
    ) {
      Swal.fire({
        text: "¿Desea anular la cita?",
        showCancelButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Anular",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.AnularCita(index);
        }
      });
    }
  }

  // Anulación de una cita
  AnularCita(index: number): void {
    if (
      !myGlobals.isNullUndefined(this.aDetalleCitas) &&
      index <= this.aDetalleCitas.length
    ) {
      // Anulamos la cita

      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.BarraProgreso,
        "",
        "Anulando cita, espere ...",
        ""
      );
      this._ApiAppService
        .AnularCita(this.aDetalleCitas[index].id_cita, false)
        .subscribe(
          (data) => {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.OperacionOk,
              "",
              "Cita anulada correctamente.",
              ""
            );
            this.aDetalleCitas = null;
            this.oSolicitanteCitasPendientes = null;
          },
          (err) => {
            myGlobals.CapturaMensajeHTTP(err, true);
          }
        );
    } else {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.Advertencia,
        "",
        "No hay ninguna cita seleccionada.",
        ""
      );
    }
  }

  // Reenvia una cita por email
  ReenviarCita(index: number): void {
    if (
      !myGlobals.isNullUndefined(this.aDetalleCitas) &&
      index <= this.aDetalleCitas.length
    ) {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.BarraProgreso,
        "",
        "Enviando cita, espere ...",
        ""
      );
      this._ApiAppService
        .EnviarEmailCita(
          this.aDetalleCitas[index].id_cita,
          Cita.GeneraHTMLCita(
            myGlobals.getNombreCliente(),
            this.aDetalleCitas[index],
            this.sEnRepresentacionDe
          )
        )
        .subscribe(
          (data) => {
            myGlobals.Mensaje(
              myGlobals.eTipoMensaje.Informacion,
              "",
              "Cita enviada correctamente.",
              ""
            );
          },
          (err) => {
            myGlobals.CapturaMensajeHTTP(err, true);
          }
        );
    } else {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.Advertencia,
        "",
        "No hay ninguna cita seleccionada.",
        ""
      );
    }
  }

  // Impresion de la cita en HTML
  ImprimirCita(index: number): void {
    if (
      !myGlobals.isNullUndefined(this.aDetalleCitas) &&
      index <= this.aDetalleCitas.length
    ) {
      Cita.ImprimirCitaHTML(
        myGlobals.getNombreCliente(),
        this.aDetalleCitas[index],
        this.sEnRepresentacionDe
      );
    } else {
      myGlobals.Mensaje(
        myGlobals.eTipoMensaje.Advertencia,
        "",
        "No hay ninguna cita seleccionada.",
        ""
      );
    }
  }
}
